<h1 mat-dialog-title *ngIf="!isLoading" xmlns="http://www.w3.org/1999/html" class="event-edit-location__title">Edit Event Venue/Location and Details</h1>
<div id="spinnerContainer" *ngIf="isLoading">
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</div>
<div *ngIf="!isLoading">
  <mat-dialog-content [formGroup]="formGroup">
    <fieldset class="event-edit-location__form-section">
      <legend class="event-edit-location__form-section-title">Event Format</legend>
      <div class="inputs">
        <mat-form-field class="event-edit-location__formItem formatField">
          <mat-label>Event Format *</mat-label>
          <mat-select formControlName="format" (selectionChange)="eventFormatSelectionChange($event)">
            <mat-option value="In-Person">In-Person</mat-option>
            <mat-option value="Online">Online</mat-option>
            <mat-option value="Both">Both</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </fieldset>

    <fieldset class="event-edit-location__form-section">
      <legend class="event-edit-location__form-section-title">Location</legend>
      <mat-form-field class="event-edit-location__formItem" *ngIf="showAddressFields">
        <mat-label>Venue/Location Name *</mat-label>
        <input formControlName="venueLocationName" matInput placeholder="Venue Name" maxlength="256"/>
      </mat-form-field>
      <h3 *ngIf="showAddressFields">Event Address *</h3>
      <div
        style="border-width: 1px; border-color: black; border-style: solid; padding: 5px; display: flex; flex-direction: column; margin-bottom: 7px;">
        <mat-form-field class="event-edit-location__formItem">
          <mat-label>Select Country *</mat-label>
          <mat-select formControlName="country" (selectionChange)="statesFieldChanged($event)">
            <mat-option value="{{country.countryCode}}" *ngFor="let country of countries">{{country.countryName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <ng-container *ngIf="showAddressFields">
        <mat-form-field class="event-edit-location__formItem">
          <mat-label *ngIf="isUSorCA()">Street 1 *</mat-label>
          <mat-label *ngIf="!isUSorCA()">Address Line 1 *</mat-label>
          <input formControlName="address1" matInput placeholder="Enter Address Line 1" maxlength="256"/>
        </mat-form-field>
        <mat-form-field class="event-edit-location__formItem">
          <mat-label *ngIf="isUSorCA()">Street 2</mat-label>
          <mat-label *ngIf="!isUSorCA()">Address Line 2</mat-label>
          <input matInput formControlName="address2" placeholder="Enter Address Line 2" maxlength="256"/>
        </mat-form-field>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Address Line 3</mat-label>
          <input matInput formControlName="address3" placeholder="Enter Address Line 3" maxlength="256"/>
        </mat-form-field>
        <div *ngIf="isUSorCA()" class="event-edit-location__horizontal-fields">
          <mat-form-field class="event-edit-location__formItem">
            <mat-label>City *</mat-label>
            <input matInput formControlName="city" placeholder="City" maxlength="256"/>
          </mat-form-field>
          <mat-form-field class="event-edit-location__formItem">
            <mat-label>Select State/Province *</mat-label>
            <mat-select *ngIf="getStates().length; else statesTextField" formControlName="stateProvince">
              <mat-option value="{{state}}" *ngFor="let state of getStates()">{{state}}</mat-option>
            </mat-select>
            <ng-template #statesTextField>
              <input matInput formControlName="stateProvince" placeholder="State/Province"/>
            </ng-template>
          </mat-form-field>
          <mat-form-field class="event-edit-location__formItem">
            <mat-label>Zip Code *</mat-label>
            <input matInput formControlName="zipcode" placeholder="Zip Code" maxlength="20"/>
          </mat-form-field>
        </div>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Latitude *</mat-label>
          <input matInput formControlName="latitude" placeholder="Enter latitude in decimal degrees" maxlength="12"/>
        </mat-form-field>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Longitude *</mat-label>
          <input matInput formControlName="longitude" placeholder="Enter longitude in decimal degrees" maxlength="12"/>
        </mat-form-field>
        <div class="event-edit-location__formItem">Note: Changing the address will also change the map pin location to match.</div>
        </ng-container>
      </div>
      <div class="event-edit-location__flex-columns" *ngIf="showAddressFields">
        <mat-checkbox formControlName="isOnAirport" color="primary" style="padding-top: 1em" class="event-edit-location__formItem">Located on Airport
          Grounds
        </mat-checkbox>
        <mat-form-field *ngIf="isUSorCA()" class="event-edit-location__formItem" style="padding-top: 1em" (focusout)="airportSearchFocusOut($event)">
          <mat-label>Select Airport</mat-label>
          <input type="text" matInput formControlName="airport" [matAutocomplete]="auto"
                 placeholder="Search Airport By Ident or Name" (keyup)="airportQueryKeyUp($event)"/>
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (onSelectionChange)="airportChange(airport)" *ngFor="let airport of airports"
                      [value]="airport.identifier + ': ' + airport.name">{{airport.identifier}}
            : {{airport.name}}</mat-option>
        </mat-autocomplete>
        <mat-error class="event-edit-location__form_field_padding" *ngIf="airportSelectionError">Invalid Airport</mat-error>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Airport Identifier</mat-label>
          <input matInput formControlName="internationalAirportId" placeholder="Enter airport identifier" maxlength="30"/>
        </mat-form-field>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Airport Name</mat-label>
          <input matInput formControlName="internationalAirportName" placeholder="Enter airport name" maxlength="256"/>
        </mat-form-field>
      </div>
    </fieldset>
        <fieldset class="event-edit-details__form-section">
          <legend class="event-edit-details__form-section-title">Date and Time</legend>
          <mat-error class="event-edit-details__form_field_padding" *ngIf="showDateError()">Start time cannot be after end time</mat-error>
          <div class="event-edit-details__horizontal-fields">
            <mat-form-field>
              <input matInput
                     name="startDate"
                     formControlName="startDate"
                     [matDatepicker]="startDate"
                     [min]="startDateMin"
                     placeholder="Pick Start Date *"
                     (dateChange)="eventDateChange('input', $event)"/>
              <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
              <mat-datepicker #startDate></mat-datepicker>

            </mat-form-field>

            <div class="event-edit-details__time-header">Select Start Time: </div>
            <mat-form-field>
              <mat-select placeholder="Hour" formControlName="startHour">
                <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="event-edit-details__time-colon">:</div>
            <mat-form-field>
              <mat-select placeholder="Minute" formControlName="startMin">
                <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-select placeholder="AM/PM" formControlName="startAMPM">
                <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="event-edit-details__horizontal-fields">
            <mat-form-field>
              <input
                name="endDate"
                formControlName="endDate"
                matInput [matDatepicker]="endPicker"
                [min]="endDateMin"
                placeholder="Pick End Date *"
                (dateChange)="eventDateChange('input', $event)"/>
              <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>

            <div class="event-edit-details__time-header">Select End Time:</div>
            <mat-form-field>
              <mat-select placeholder="Hour" formControlName="endHour">
                <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div class="event-edit-details__time-colon">:</div>
            <mat-form-field>
              <mat-select placeholder="Minute" formControlName="endMin">
                <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-select placeholder="AM/PM" formControlName="endAMPM">
                <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-form-field class="event-edit-details__formItemSmallText">
            <mat-label>Time Zone *</mat-label>
            <mat-select formControlName="timezone">
              <mat-option value="{{tz.zoneName}}" *ngFor="let tz of timezones">{{tz.zoneName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </fieldset>
        <fieldset class="event-edit-details__form-section">
          <legend class="event-edit-details__form-section-title">Website/Registration</legend>
          <mat-form-field id="websiteRegistrationField" class="event-edit-details__formItem">
            <input matInput
                   placeholder="Event Registration Link"
                   formControlName="webinarRegistrationLink" maxlength="256">
          </mat-form-field>
          <mat-form-field id="websiteInformationField" class="event-edit-details__formItem">
            <input matInput
                   placeholder="Event Info Website Link"
                   formControlName="informationWebsite" maxlength="256">
          </mat-form-field>
          <mat-form-field id="websiteCustomLabelField" class="event-edit-details__formItem">
            <input matInput
                   placeholder="Event Website Custom Label"
                   formControlName="websiteCustomLabel" maxlength="50">
          </mat-form-field>
        </fieldset>
        <fieldset class="event-edit-details__form-section">
          <legend class="event-edit-details__form-section-title">Basic Event Settings</legend>
          <mat-form-field class="event-edit-details__formItem">
            <mat-label>Event Type *</mat-label>
            <mat-select formControlName="type">
              <mat-option value="{{eventType}}" *ngFor="let eventType of eventTypes">{{eventType}}</mat-option>
            </mat-select>
          </mat-form-field>
          <!-- <mat-form-field class="formItem">
            <mat-label>Event Format *</mat-label>
            <mat-select formControlName="format">
              <mat-option value="In-Person">In-Person</mat-option>
              <mat-option value="Online">Online</mat-option>
              <mat-option value="Both">Both</mat-option>
            </mat-select>
          </mat-form-field> -->
          <mat-form-field id="costField" class="event-edit-details__formItem">
            <input matInput
                   placeholder="Event Cost"
                   formControlName="cost" maxlength="256">
          </mat-form-field>
        </fieldset>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="submit-button mat-raised-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
